enum footerTestIds {
	lastLogin = 'footer-last-login',
	footerLinks = 'footer-nav-links',
}

export default footerTestIds;
